import * as yup from 'yup';
import { EducationSchema } from './education.schema';

export const EditProfileSchema = yup.object({
  firstName: yup.string().label('First Name').required(),
  lastName: yup.string().label('Last Name').required(),
  profileEducations: yup.array().of(EducationSchema).optional(),
});
